import template from 'bundle-text:./index.html';

export const Intro = () => {
  return template;
};

export default Intro;
